import Vue from 'vue';
import VueRouter from 'vue-router';
import Home from '../views/Home';
import RaceCalendar from '../views/RaceCalendar';
import PageNotFound from '../views/PageNotFound';
import News from '../views/News';
import Page from '../views/Page';
import i18n from '../i18n';
import RaceCalendarDetail from '../views/RaceCalendarDetail';
import NewsDetail from '../views/NewsDetail';
import redirects from '../assets/json/redirects.json';
import FutureStage from '../views/FutureStage';

Vue.use(VueRouter);

const routes = [];
// add redirects from static json list
redirects.forEach(entry => {
  routes.push(entry);
});
// add internal routes after redirects
routes.push(
  {
    path: '/:lang',
    name: 'home',
    component: Home
  },
  {
    path: '/:lang/dtm-trophy',
    name: 'homeTrophy',
    component: Home
  },
  {
    path: '/:lang/esports',
    name: 'homeEsports',
    component: Home
  },
  {
    path: '/:lang/future',
    name: 'futureStage',
    component: FutureStage
  },
  {
    path: `/:lang/${i18n.t('navigation.events')}`,
    name: `${i18n.t('navigation.events')}`,
    component: RaceCalendar
  },
  {
    path: `/:lang/${i18n.t('navigation.events')}/:slug`,
    name: `${i18n.t('navigation.eventsDetail')}`,
    component: RaceCalendarDetail
  },
  {
    path: `/:lang/${i18n.t('navigation.news')}`,
    name: `${i18n.t('navigation.news')}`,
    component: News
  },
  {
    path: `/:lang/dtm-trophy/${i18n.t('navigation.news')}`,
    name: `${i18n.t('navigation.newsTrophy')}`,
    component: News
  },
  {
    path: `/:lang/${i18n.t('navigation.news')}/:slug`,
    name: `${i18n.t('navigation.newsDetail')}`,
    component: NewsDetail
  },
  {
    path: '/:lang/*',
    name: 'page',
    component: Page
  },
  {
    path: '/',
    redirect: `/${i18n.locale}`
  },
  {
    path: '*',
    component: PageNotFound
  }
);

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
});

router.afterEach((to, from) => {
  const lang = to.params.lang;
  if (to.name !== i18n.t('navigation.eventsDetail') && ['ru', 'sv', 'it', 'nl'].includes(lang)) {
    router.replace({ name: to.name, params: { lang: 'en', pathMatch: to.params.pathMatch } });
    router.go(0);
  }
});

export default router;
